import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { Listing } from '../../../classes/listing';
import { ListingsService } from '../../../services/listings.service';
import { HasSubscriptions } from '../../has-subscriptions';
import { PreferencesService } from '../../../services/preferences.service';
import { UserService } from '../../../services/user.service';
import { User } from '../../../classes/user';
import { HistoryItem } from '../../../classes/history-item';
import { RoutingHistoryService } from '../../../services/routing-history.service';

@Component({
  selector: 'app-favourite-listings',
  templateUrl: './favourite-listings.component.html',
  styleUrls: ['./favourite-listings.component.scss']
})
export class FavouriteListingsComponent extends HasSubscriptions implements OnInit {
  @Output() wentToFindSome = new EventEmitter<void>();
  favourites: Listing[] = [];

  constructor(
    private listingsService: ListingsService,
    private _preferencesService: PreferencesService,
    private userService: UserService,
    private _historyService: RoutingHistoryService
  ) {
    super();
  }

  async ngOnInit() {
    this.addSub(this._preferencesService.favouriteListingsChanged.subscribe(async (favIds) => {
      const response = await this.listingsService.getListingsPreview(favIds.join(',')).catch((error) => null);
      if (response === null || response.results === null || response.results.length === 0) {
        this.favourites = [];
      } else {
        response.results.forEach((part, index, theArray) => theArray[index].isFavourite = true);
        this.favourites = response.results;
      }
    }));

    this.addSub(this.userService.currentUser.subscribe(user => this._historyService.push(new HistoryItem({fromFavouritesPage: true}))));
  }

  async onFavouriteClicked(listing: Listing) {
    const offset = this.favourites.findIndex((fav) => fav === listing);
    // We always start at 0 offset on since we only return elements after the one selected
    this._preferencesService.addNextListings(this.favourites.slice(offset, this.favourites.length).map((l) => ({listingId: l.listingId, detailUrl: l.detailUrl})));
  }
}
